import Facility from './facility.js';
export default Facility;
